import Route from '@ember/routing/route';

export default class StartValidateRoute extends Route
{
	model()
	{
		return this.modelFor("event");
	}
}
